export default "__VITE_ASSET__CUCCwvT2__"